import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class ReporteService {

  constructor(
    private http: HttpClient
  ) { }

  getCommonReports() {
    return this.http.get<any>(`${environment.BACKEND}reporte/list`);
  }

  getReportsByUser() {
    return this.http.get<any>(`${environment.BACKEND}reporte/reportesPorUsuario`);
  }

}
